// extracted by css-extract-rspack-plugin
export default {"container":"uvAxCXIjlXMBJFQh","link":"K9irqYzVM_kZG4UG"};